module.exports = __webpack_public_path__ + "static/media/danoneLogo.38b7403e.png";